
import React from "react";
import  {  componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { defaultDropList,  } from "../Data/WBComponentDefaults";

import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import {  ResizeableType, WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";




export default class WBRichText extends WBComponent {

    


    constructor(){
        super();
        this.typename = wBComponentTypeNames.richText;
        this.displayName = "Rich Text";
        this.dropList = defaultDropList;
        this.editList = ["width","height",componentAttributeTypes.customCSS];
        this.primaryEditAttributes = [];
        this.hideAdvancedSettings = false
        this.contentEditable = true;
        this.icon = (<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"  height="1em" viewBox="0 0 10.54995 9.8280106" version="1.1" id="svg5">
        <defs id="defs2"/>
        <g id="layer1" transform="matrix(1,0,0,0.94952295,-45.677234,-114.95119)">
          <rect  id="rect398-0-3" width="9.9624443" height="1.0140897" x="45.970985" y="130.31078" ry="0.50704485"/>
          <rect  width="9.9624443" height="1.0140897" x="45.970985" y="128.1073" ry="0.50704485"/>
          <rect  width="5.1141405" height="1.0140897" x="50.81929" y="125.90382" ry="0.50704485"/>
          <rect  width="5.1141415" height="1.0140897" x="50.81929" y="123.70033" ry="0.50704485"/>
        </g>
        <g aria-label="T" id="text849">
          <path d="M 5.1420562,0.07418535 V 1.5589906 H 4.9964077 Q 4.8669424,1.0451752 4.7091565,0.82265669 4.5513707,0.59609239 4.2762569,0.46258129 4.1225168,0.38975705 3.7381667,0.38975705 H 3.3295418 V 4.6216544 q 0,0.4207623 0.044504,0.5259529 0.04855,0.1051905 0.1820606,0.1861063 0.1375569,0.07687 0.3722128,0.07687 H 4.1103795 V 5.5602779 H 1.2378679 V 5.4105837 h 0.1820606 q 0.2387016,0 0.3843501,-0.084962 Q 1.9094692,5.2689807 1.970156,5.1314237 2.01466,5.0343247 2.01466,4.621654 V 0.38975705 H 1.6181722 q -0.5542734,0 -0.8051124,0.23465588 Q 0.46107598,0.952122 0.36802279,1.5589906 H 0.21428273 V 0.07418535 Z"  id="path1167"/>
        </g>
      </svg>)

          this.resizeType = ResizeableType.None;
    }



    


    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps)
     {


      let atts = GetNodeDomAttributes(" rich-text v-text w-full no-expand",component,screenSize,isEditor)


      // if(!component.content||component.content==""||component.content=="Your Text Here"||component.content=="<p>Your Text Here</p>")
      //   atts.style = {...atts.style,minHeight:"50vh"}
     
   
        return (


            <div  {...atts}  dangerouslySetInnerHTML={{ __html: component.content??"" }}>

            </div>
        )

    }

}